import { IAgent } from "../../models/agent.interface";
import { initialState } from "../reducers/root.reducer";
import { AgentAction } from "../actions/agent.actions";
import { AgentActionTypes } from "../actions/types";

export const agentReducer = (
  state: IAgent | null = initialState.agent,
  action: AgentAction
) => {
  switch (action.type) {
    case AgentActionTypes.GET_LOGO:
      return state;
    case AgentActionTypes.GET_LOGO_COMPLETED:
      const logo = action.payload ? action.payload.logo : "";
      const agentCode = action.payload ? action.payload.agentCode : "";
      return { ...state, logo, agentCode, telephone: action != null && action.payload != null ?  action.payload.telephone : "" };
    default:
      return state;
  }
};
